import { Component, Prop, Vue } from 'vue-property-decorator';
import { WidgetData } from "@/components/Dashboard/Widgets/types/Widget";

@Component
export default class WidgetList extends Vue {
    private widgetItems: WidgetData[] = []
    private contentLength = 0

    @Prop()
    private widgetLimit!: number

    created(): void {
        this.getWidgetItems()
        this.$eventHub.$on('countContents', (length: number) => {
            this.contentLength = length
        })
    }

    private getWidgetItems() {
        this.$apiClient.doRequest('get', `/admin/widgets`).then((ret) => {
            this.widgetItems = ret
        })
    }

    private addContent(item: WidgetData) {
        this.$eventHub.$emit('getContentsCount')
        if (this.contentLength >= this.widgetLimit) {
            alert(`配置できるウィジェットは${this.widgetLimit}個までです。`)
        } else {
            const widgetData: WidgetData = {
                id: item.id,
                title: item.title,
                component: item.component,
                config: null
            }
            this.$emit('openModal', widgetData, false)
        }
    }
}